import script from "./TransferAdults.vue?vue&type=script&setup=true&lang=js"
export * from "./TransferAdults.vue?vue&type=script&setup=true&lang=js"

import "./TransferAdults.vue?vue&type=style&index=0&id=1a0bd916&lang=scss"

const __exports__ = script;

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QField,QIcon});
